import { VehicleType } from "../enums/vehicle-type.enum";
import { FuelType } from "../enums/fuel-type.enum";

export function getVehicleTypeLabel(value: number): string {
  switch (value) {
    case VehicleType.TURISMO: return 'tourism';
    case VehicleType.MONOVOLUMEN: return 'minivan';
    case VehicleType.TODOTERRENO: return 'atv';
    case VehicleType.SUV: return 'suv';
    case VehicleType.COUPE: return 'coupe';
    default: return 'Desconocido';
  }
}

export function getVehicleTypeOptions(): { label: string, value: number }[] {
  return Object.keys(VehicleType)
    .filter(key => !isNaN(Number(VehicleType[key as any])))
    .map(key => {
      const value = Number(VehicleType[key as any]);
      return {
        label: getVehicleTypeLabel(value),
        value
      };
    });
}


export function getFuelTypeLabel(value: number): string {
    switch (value) {
      case FuelType.PETROL: return 'petrol';
      case FuelType.DIESEL: return 'diesel';
      case FuelType.ELECTRIC: return 'electric';
      case FuelType.HYBRID: return 'hybrid';
      default: return 'Desconocido';
    }
  }
  
  export function getFuelTypeOptions(): { label: string; value: number }[] {
    return Object.keys(FuelType)
      .filter(key => !isNaN(Number(FuelType[key as any])))
      .map(key => {
        const value = Number(FuelType[key as any]);
        return {
          label: getFuelTypeLabel(value),
          value
        };
      });
  }